export const methodsDictionary = {
  method: 'Method',
  name2: 'Nomi',
  successMethodEdit: 'Metod muvaffaqiyatli o`zgartirildi',
}
